import React, { Suspense } from 'react'
import Authenticator from '../Authenticator'
import ErrorBoundary from '../ErrorBoundary'
import { ContentContainer } from '../../Styles'
import Spinner from '../Spinner/Spinner'
interface CompProps {
  children: any
}

const AppWrapper: React.FC<CompProps> = ({ children }) => (
  <ContentContainer>
    <ErrorBoundary>
      <Suspense fallback={<Spinner fullScreen={true} />}>
        <Authenticator requireAuth={false}>{children}</Authenticator>
      </Suspense>
    </ErrorBoundary>
  </ContentContainer>
)

export default AppWrapper
